export default {
  header: "My Cards Page",
  view: "Cards"
};
